export function sma(data, period) {
  const out = new Array(data.length).fill(null)
  for (let i = period - 1; i < data.length; i++) {
    let s = 0
    for (let j = i - period + 1; j <= i; j++) s += data[j].close
    out[i] = s / period
  }
  return out
}

export function ema(data, period) {
  const out = new Array(data.length).fill(null)
  const k = 2 / (period + 1)
  let prev = null
  for (let i = 0; i < data.length; i++) {
    if (i < period - 1) continue
    if (i === period - 1) {
      let s = 0
      for (let j = 0; j < period; j++) s += data[j].close
      prev = s / period
    } else {
      prev = data[i].close * k + prev * (1 - k)
    }
    out[i] = prev
  }
  return out
}
